import React from "react"; // Import icons
import { useNavigate } from "react-router-dom"; // For navigation
import useScrollAnimation from "./useScrollAnimation"; // For scroll animation
import { FaCode, FaMobileAlt, FaCog, FaBullhorn } from "react-icons/fa";

const ServiceSection: React.FC = () => {
  useScrollAnimation(); // Hook for scroll animations
  const navigate = useNavigate(); // For routing to services page

  return (
    <section className="text-[#111010] py-5 pb-6 px-8 relative z-30 bg-[#f4f4f5]">
      {/* Wrapper for entire content */}
      <div className="flex flex-col gap-8 md:flex-row z-30 animate-on-scrollUp">
        {/* Header Section */}
        <div className="max-w-7xl mx-auto text-center md:mt-[8vh]">
          <h2 className="text-[#ae0c00] relative uppercase text-lg z-30">
            About Us
          </h2>
          <h1 className="text-4xl font-bold mt-2 relative z-30">What We Do?</h1>
          <p className="text-gray-900 mt-4 max-w-2xl relative mx-auto">
            We specialize in providing cutting-edge digital solutions tailored
            to your business needs, empowering your growth in the digital age.
            Whether you need a robust website, a feature-rich mobile app, or
            custom software solutions, we have you covered.
          </p>
          <button
            onClick={() => navigate("/services")}
            className="relative group mb-8 text-[#111010] mt-4 font-bold py-4 px-6 border-none bg-transparent tracking-wide transition-all duration-500"
          >
            VIEW ALL SERVICES
            {/* Button border animation */}
            <span className="absolute top-0 left-0 w-full md:w-5 h-0.5 bg-[#ae0c00] transition-all duration-500 group-hover:w-full"></span>
            <span className="absolute top-0 left-0 w-0.5 h-full md:h-5 bg-[#ae0c00] transition-all duration-500 group-hover:h-full"></span>
            <span className="absolute bottom-0 right-0 w-full md:w-5 h-0.5 bg-[#ae0c00] transition-all duration-500 group-hover:w-full"></span>
            <span className="absolute bottom-0 right-0 w-0.5 h-full md:h-5 bg-[#ae0c00] transition-all duration-500 group-hover:h-full"></span>
          </button>
        </div>

        {/* Service Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 z-30">
          {/* First Card */}
          <div className="p-6 rounded-lg text-center">
            <FaCode className="text-4xl text-[#ae0c00] hover:scale-110 hover:rotate-12 transition-transform duration-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Website & Web Apps</h3>
            <p className="text-gray-500 text-sm">
              Build responsive and high-performing websites or web applications
              that provide seamless user experiences and enhance your digital
              presence.
            </p>
          </div>

          {/* Second Card */}
          <div className="p-6 rounded-lg text-center z-30">
            <FaMobileAlt className="text-4xl text-[#ae0c00] hover:scale-110 hover:rotate-12 transition-transform duration-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Mobile Applications</h3>
            <p className="text-gray-500 text-sm">
              Develop powerful mobile apps for iOS and Android that drive user
              engagement and help your business stay connected with customers
              on-the-go.
            </p>
          </div>

          {/* Third Card */}
          <div className="p-6 rounded-lg text-center z-30">
            <FaCog className="text-4xl text-[#ae0c00] hover:scale-110 hover:rotate-12 transition-transform duration-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Custom Software</h3>
            <p className="text-gray-500 text-sm">
              Tailor-made software solutions designed specifically for your
              business processes, improving efficiency, automation, and
              scalability.
            </p>
          </div>

          {/* Fourth Card */}
          <div className="p-6 rounded-lg text-center z-30">
            <FaBullhorn className="text-4xl text-[#ae0c00] hover:scale-110 hover:rotate-12 transition-transform duration-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Digital Marketing</h3>
            <p className="text-gray-500 text-sm">
              Comprehensive digital marketing services, from SEO to social media
              marketing, to help you grow your online presence and reach your
              target audience effectively.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
